var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "d-flex align-items-center text-center mt-4" },
    [
      _c(
        "div",
        { staticClass: "w-100" },
        [
          _c("v-card-title", { staticClass: "card-title" }, [
            _vm._v(" Contacto "),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "pa-3" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseInput", {
                        attrs: {
                          label: "Dirección",
                          name: "address",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "address", $$v)
                          },
                          expression: "legajo.address",
                        },
                      }),
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Provincia",
                          name: "province",
                          items: _vm.provinces,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_provinces,
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.province,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "province", $$v)
                          },
                          expression: "legajo.province",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "Observaciones",
                          name: "observations",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.observations,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "observations", $$v)
                          },
                          expression: "legajo.observations",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseInput", {
                        attrs: {
                          label: "Código postal",
                          name: "postal_code",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.postal_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "postal_code", $$v)
                          },
                          expression: "legajo.postal_code",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "Email",
                          name: "email",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "email", $$v)
                          },
                          expression: "legajo.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseInput", {
                        attrs: {
                          label: "Localidad",
                          name: "locality",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.locality,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "locality", $$v)
                          },
                          expression: "legajo.locality",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "Teléfono",
                          name: "phone",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "phone", $$v)
                          },
                          expression: "legajo.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }